var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _rect5, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7Z(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#152536"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.277 111L117.97 52.2273V51.75H83.5043V41.1818H131.061V51.9886L101.402 111H88.277ZM141.45 111V103.125L177.246 51.7841H141.246V41.1818H192.928V49.0568L157.166 100.398H193.132V111H141.45Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 215,
    width: 121,
    height: 200,
    rx: 16,
    fill: "#152536"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M342 384.284H334.125L282.784 348.489V384.489H272.182V332.807H280.057L331.398 368.568V332.602H342V384.284ZM272.182 307.716H342V320.364H272.182V307.716ZM342 294.02H272.182V267.838C272.182 262.474 273.182 257.974 275.182 254.338C277.182 250.679 279.932 247.918 283.432 246.054C286.909 244.168 290.864 243.224 295.295 243.224C299.773 243.224 303.75 244.168 307.227 246.054C310.705 247.94 313.443 250.724 315.443 254.406C317.42 258.088 318.409 262.622 318.409 268.009V285.361H308.011V269.713C308.011 266.577 307.466 264.009 306.375 262.009C305.284 260.009 303.784 258.531 301.875 257.577C299.966 256.599 297.773 256.111 295.295 256.111C292.818 256.111 290.636 256.599 288.75 257.577C286.864 258.531 285.398 260.02 284.352 262.043C283.284 264.043 282.75 266.622 282.75 269.781V281.372H342V294.02Z",
    fill: "#FAFAFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.723 382L178.923 276.699V275.844H117.172V256.909H202.378V276.271L149.238 382H125.723Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_806",
    x: 71.5039,
    y: 41.1836,
    width: 125.629,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_806"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_806",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Z);
export default __webpack_public_path__ + "static/media/7z.5dd6dda423dbcf59051a65b31dec9c5b.svg";
export { ForwardRef as ReactComponent };